import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { CalendarDays, ClipboardEdit, PlayCircle } from "lucide-react";
import { fetchManagerPerformanceDashboardRequest } from "../../../redux/actions/performanceActions";
import "../PerformanceStyles.css";
import { asArray, statusTone, formatStatus } from "../Collaborateur/performanceUi";
import EntretienAnnuelModal from "../components/EntretienAnnuelModal";

export default function PerformanceManagerCollaborateurs() {
    const { campagneId } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const manager = useSelector((state) => state.performance.manager);
    const collaborateurs = asArray(manager.collaborateursByCampagneId[String(campagneId)]);
    const loading = manager.loadingByCampagneId[String(campagneId)];
    const error = manager.errorByCampagneId[String(campagneId)];
    const [planificationProgressId, setPlanificationProgressId] = useState(null);

    useEffect(() => {
        dispatch(fetchManagerPerformanceDashboardRequest(campagneId));
    }, [dispatch, campagneId]);

    const openEvaluation = (progressId) => {
        if (!progressId) return;
        navigate(`/performance/manager/evaluation/${progressId}`);
    };

    const openConsultation = (progressId) => {
        if (!progressId) return;
        navigate(`/performance/manager/evaluation/${progressId}?mode=consultation`);
    };

    const openRevision = (progressId) => {
        if (!progressId) return;
        navigate(`/performance/manager/evaluation/${progressId}?mode=revision`);
    };

    const primaryActionLabel = (collaborateur) => {
        if (collaborateur.globalStatus === "COMPLETED" || Number(collaborateur.progressionPourcentage) >= 100) return "Consulter";
        if (collaborateur.globalStatus === "IN_PROGRESS") return "Reprendre";
        if (collaborateur.globalStatus === "NOT_STARTED" || Number(collaborateur.progressionPourcentage || 0) === 0) return "Evaluer";
        return "Reprendre";
    };

    const openPrimaryAction = (collaborateur) => {
        if (primaryActionLabel(collaborateur) === "Consulter") openConsultation(collaborateur.evaluationProgressId);
        else openEvaluation(collaborateur.evaluationProgressId);
    };

    return (
        <main className="perf-page">
            <header className="perf-header" />
            {loading && <div className="perf-state">Chargement des collaborateurs...</div>}
            {error && <div className="perf-state perf-state--error">{error}</div>}
            {!loading && !error && collaborateurs.length === 0 && <div className="perf-state">Aucun collaborateur rattache a cette campagne.</div>}
            {!loading && !error && collaborateurs.length > 0 && (
                <section className="perf-table-wrap">
                    <table className="perf-table">
                        <thead>
                        <tr>
                            <th>Collaborateur</th>
                            <th>Poste</th>
                            <th>Direction</th>
                            <th>Statut</th>
                            <th>Progression</th>
                            <th>Actions</th>
                        </tr>
                        </thead>
                        <tbody>
                        {collaborateurs.map((collaborateur) => (
                            <tr key={collaborateur.evaluationProgressId}>
                                <td>{collaborateur.collaborateurNom || "-"}</td>
                                <td>{collaborateur.jobName || "-"}</td>
                                <td>{collaborateur.entityName || "-"}</td>
                                <td><span className={`perf-badge perf-badge--${statusTone(collaborateur.globalStatus)}`}>{formatStatus(collaborateur.globalStatus)}</span></td>
                                <td>{collaborateur.progressionPourcentage ?? 0}%</td>
                                <td>
                                    <div className="perf-actions perf-actions--table">
                                        <button className="perf-btn perf-btn--primary perf-btn--table-main" type="button" disabled={!collaborateur.evaluationProgressId} onClick={() => openPrimaryAction(collaborateur)}>
                                            <PlayCircle size={15} />
                                            {primaryActionLabel(collaborateur)}
                                        </button>
                                        <button className="perf-btn perf-btn--table-secondary" type="button" disabled={!collaborateur.evaluationProgressId} onClick={() => openRevision(collaborateur.evaluationProgressId)}>
                                            <ClipboardEdit size={15} />
                                            Réviser
                                        </button>
                                        <button className="perf-btn perf-btn--table-plan" type="button" disabled={!collaborateur.evaluationProgressId} onClick={() => setPlanificationProgressId(collaborateur.evaluationProgressId)}>
                                            <CalendarDays size={15} />
                                            Planifier entretien
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </section>
            )}
            <EntretienAnnuelModal
                open={Boolean(planificationProgressId)}
                progressId={planificationProgressId}
                title="Invitation entretien annuel"
                onClose={() => setPlanificationProgressId(null)}
                showManagerActions
            />
        </main>
    );
}
